<template>
  <div class="basicStyle">
    <el-card class="box-card">
      <el-form
        :inline="true"
        :model="searchFormObj"
        class="demo-form-inline"
        size="mini"
      >
        <el-form-item label="提交时间：" class="inline-form-item">
          <el-date-picker
            v-model="timeArr"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="" class="inline-form-item form-item-margin">
          <el-input
            v-model="searchFormObj.keywords"
            clearable
            placeholder="请输入姓名、手机号"
          />
        </el-form-item>
        <el-form-item>
          <!-- <el-button
            type="primary"
            icon="el-icon-search"
            @click="onSearchSubmit"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            icon="el-icon-refresh"
            @click="onSearchEmptySubmit"
            >重置</el-button
          >-->
          <MyButton
            value="搜索"
            size="medium"
            icon="el-icon-search"
            type="1"
            @click="onSearchSubmit"
          ></MyButton>
          <MyButton
            value="重置"
            size="medium"
            type="2"
            @click="onSearchEmptySubmit"
          ></MyButton>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="table_box">
      <el-table
        v-loading="isLoading"
        :data="studentTableDataArr"
        style="width: 100%"
        border
        size="mini"
      >
        <el-table-column prop="id" label="记录ID" align="center" />
        <el-table-column prop="tob_uid" label="用户ID" align="center" />
        <el-table-column prop="name" label="姓名" align="center" />
        <el-table-column prop="mobile" label="手机号码" align="center" />
        <el-table-column prop="app_name" label="考试名称" align="center" />
        <el-table-column prop="school_name" label="毕业学校" align="center" />
        <el-table-column prop="province_name" label="所在省" align="center" />
        <el-table-column prop="city_name" label="市" align="center" />
        <el-table-column
          prop="score_str"
          label="预计分数/全科总分"
          align="center"
        />
        <el-table-column prop="updated_at" label="提交时间" align="center" />
        <el-table-column prop="remark" label="备注" align="center" />
        <el-table-column prop="teacher_name" label="招生老师" align="center" />
      </el-table>
    </div>

    <div class="page_box">
      <el-pagination
        :current-page="searchFormObj.page"
        background
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchFormObj.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// import recruitStudentApi from "@/api/recruitStudent";
import commonApi from "@/api/common";
import { deepClone } from "@/utils";
import recruitStudentApi from "@/api/recruitStudent";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "recruitStudentTable", // 招生表单
  components: {
    MyButton,
  },
  data() {
    return {
      searchFormObj: {
        keywords: "",
        limit: 20,
        page: 1,
      }, // 搜索数据
      timeArr: [], // 加入时间数组
      isLoading: false, // 表单加载状态
      total: 0, // 数据总数
      studentTableDataArr: [], // 学生表单数据
    };
  },
  created() {
    // 获取问号中的显示内容
    // this.getDic();
    this.getList();
  },
  methods: {
    // 提交搜索表单
    onSearchSubmit() {
      console.log("搜索");
      this.searchFormObj.page = 1;
      this.getList();
    },
    // 重置表单
    onSearchEmptySubmit() {
      console.log("重置");
      this.searchFormObj = {
        keywords: "",
        limit: 20,
        page: 1,
      };
      this.timeArr = [];
      this.getList();
    },
    // 每页尺寸改变函数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchFormObj.limit = val;
      this.searchFormObj.page = 1;
      this.getList();
    },
    // 页码改变函数
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchFormObj.page = val;
      this.getList();
    },
    // 获取表单数据函数
    getList() {
      console.log("表单提交");
      this.isLoading = true;
      const query = deepClone(this.searchFormObj);
      console.log("timeArr", this.timeArr);
      if (this.timeArr && this.timeArr.length == 2) {
        query.start_date = this.timeArr[0];
        query.end_date = this.timeArr[1];
      }
      console.log("query", query);
      recruitStudentApi.getRecruitSignupList(query).then((res) => {
        if (res.code === 200) {
          this.studentTableDataArr = res.data.list.data;
          this.total = res.data.list.total;
          this.isLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .box-card {
  padding: 20px 12px 0 12px;
  /deep/ .el-card__body {
    padding: 20px 0px;
  }
  /deep/ .el-form-item {
    margin-right: 0;
    .el-button {
      margin-left: 20px;
    }
  }
}
.form-item-margin {
  margin-left: 20px;
}
.table_box {
  margin-top: 20px;
}
.page_box {
  margin-top: 20px;
}
.money-box {
  text-align: end;
  margin-top: 12px;
  font-size: 16px;
  span {
    color: #d9001b;
  }
}
</style>
